import { useStaticQuery, graphql } from "gatsby"

export const useSectionHeroData = () => {
  const data = useStaticQuery(graphql`
    query heroQuery {
      allContentfulSectionHero {
        edges {
          node {
            id
            heading01
            heading03
            cta {
              text
              to
            }
            ctaLink {
              text
              to
            }
            rollingText
            sliderImages {
              raw
              references {
                url
                filename
                gatsbyImageData(layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    }
  `)

  return data.allContentfulSectionHero.edges[0].node
}